import { StoreOrderService } from 'application/services/store-order'
import { api } from 'infra/adapters/http-client-adapter'

export const handleStoreOrder = new StoreOrderService(api)
